import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

function DataArray(props: Readonly<SvgIconProps>): JSX.Element {
  return (
    <SvgIcon height='24px' viewBox='0 -960 960 960' width='24px' fill='#000' {...props}>
      <path d='M600-160v-80h120v-480H600v-80h200v640H600Zm-440 0v-640h200v80H240v480h120v80H160Z' />
    </SvgIcon>);
}

export default React.memo(DataArray);
